import React from 'react'

import { ReportResult } from '../../models/ReportResult'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../app/design/Table'
import { ReportIcon } from './ReportIcon'

type Props = {
    rows: ReportResult[]
    metricName: string
    onClick: (data: ReportResult) => void
}

const ReportDetailsTable: React.FC<Props> = ({ rows, metricName, onClick }) => {
    const hasThirdColumn = rows.some((row) => row.total?.totalString)
    return (
        <Table>
            <TableHeader>
                <TableRow>
                    <TableHead className="font-normal!">Name</TableHead>
                    <TableHead className={`font-normal! ${!hasThirdColumn ? 'text-right' : ''}`}>
                        Date
                    </TableHead>
                    {hasThirdColumn && (
                        <TableHead className="text-right font-normal!">{metricName}</TableHead>
                    )}
                </TableRow>
            </TableHeader>
            <TableBody>
                {rows.map((row, index) => (
                    <TableRow
                        className="cursor-pointer"
                        key={`${row.id}-${index}`}
                        onClick={() => onClick(row)}
                    >
                        <TableCell>
                            <div className="rowTitle">
                                <div className="icon">
                                    <ReportIcon result={row} />
                                </div>
                                <div className="title">{row.title}</div>
                            </div>
                        </TableCell>
                        <TableCell className={!hasThirdColumn ? 'text-right' : ''}>
                            {row.subtitle}
                        </TableCell>
                        {hasThirdColumn && (
                            <TableCell className="text-right">{row.total?.totalString}</TableCell>
                        )}
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    )
}

export default ReportDetailsTable
